import React from 'react';
import { Wrench } from 'lucide-react';
import { Card } from '../ui/Card';

interface AuthLayoutProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

/**
 * Shared shell for every authentication page (login, registration, password
 * recovery). Keeps branding, header and footer consistent and reusable.
 */
export const AuthLayout: React.FC<AuthLayoutProps> = ({ title, subtitle, children, footer }) => {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex flex-col">
      <header className="h-16 shrink-0 border-b border-slate-800 bg-slate-900/80 backdrop-blur-md px-4 sm:px-6 flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <div className="p-2 bg-sky-500/10 text-sky-400 rounded-xl">
            <Wrench className="w-5 h-5" />
          </div>
          <div>
            <h1 className="text-sm font-semibold text-slate-100 leading-tight">NAD PROJECT</h1>
            <p className="text-[10px] font-medium text-slate-400">Maintenance &amp; Complaints</p>
          </div>
        </div>
        <span className="hidden sm:inline text-[10px] font-medium uppercase tracking-wider text-slate-500">
          Secure Access
        </span>
      </header>

      <main className="flex-1 flex items-center justify-center px-4 py-10">
        <div className="w-full max-w-md">
          <Card title={title} subtitle={subtitle} titleClassName="text-lg">
            {children}
          </Card>
          {footer && <div className="text-center text-xs text-slate-400 mt-5">{footer}</div>}
        </div>
      </main>

      <footer className="shrink-0 border-t border-slate-800 py-4 px-4 text-center">
        <p className="text-xs text-slate-500">
          Designed By:{' '}
          <a
            href="https://aartitechservices.pages.dev"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-sky-400 hover:text-sky-300 hover:underline"
          >
            Aarti Tech Services
          </a>
        </p>
      </footer>
    </div>
  );
};
